import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { PriceCampaignService } from '../../../../core/catalog';
import { SapPriceCampaignList } from '../../../../core/model';
import { NavigationNode } from '../../cms-libs/navigation/navigation-node.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'li[py-my-page-menu-list-item]',
  templateUrl: './my-page-menu-list-item.component.html',
  styleUrls: ['./my-page-menu-list-item.component.scss'],
  standalone: false,
})
export class MypageMenuListItemComponent implements OnInit {
  @Input() item: NavigationNode;
  @Input() notificationCount: number;

  isCollapsed = true;
  priceCampaigns$: Observable<SapPriceCampaignList>;

  constructor(
    protected router: Router,
    private priceCampaignService: PriceCampaignService,
    private routingService: RoutingService
  ) {}

  ngOnInit(): void {
    this.priceCampaigns$ = this.priceCampaignService.getAvailablePriceCampaigns();

    if (this.hasActiveChildRoute()) {
      this.isCollapsed = false;
    }
  }

  isUrlActive(url: string | string[]): boolean {
    if (url?.toString()) {
      return this.router.isActive(url.toString(), false);
    }
    return false;
  }

  parseIcon(styleClasses: string = '') {
    switch (styleClasses) {
      case 'dashboard-link':
        return 'appstore';

      case 'orders-link':
        return 'bars';

      case 'shopping-lists-link':
        return 'heart';

      case 'my-assortment-link':
        return 'tag';

      case 'statistics-link':
        return 'bar-chart';

      case 'settings-link':
        return 'setting';

      case 'logout-link':
        return 'logout';

      case 'delivery-addresses-link':
        return 'environment';

      case 'price-files-link':
        return 'file-text';

      case 'accounting-codes-link':
        return 'file-excel';

      case 'order-cards-link':
        return 'solution';

      case 'order-cards-admin-link':
        return 'solution';

      case 'approvals-link':
        return 'carry-out';

      case 'users-link':
        return 'team';

      case 'areas-of-use-admin-link':
        return 'read';

      case 'purchase-limits-link':
        return 'safety';

      case 'campaigns-link':
        return 'percentage';

      default:
        return 'minus';
    }
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  navigateToPriceCampaign(link: string): void {
    this.routingService.goByUrl(link);
  }

  hasActiveChildRoute(): boolean {
    return this.item.children?.some((child) => {
      if (child.url) {
        return this.router.isActive(child.url.toString(), false);
      }
    });
  }
}
